import { Autocomplete, Box, InputAdornment, TextField } from '@mui/material'
import { CountryCode } from 'api/models/GetAddress.type'
import countries from 'i18n-iso-countries'
import { Dispatch, forwardRef } from 'react'
import { useFormContext } from 'react-hook-form'
import { FlagImage } from 'react-international-phone'

export const CountrySelect = forwardRef<HTMLDivElement, any>(
  function CountrySelect(
    {
      value,
      onChange,
      ...field
    }: {
      value: string
      onChange: (code: string) => void
      setCompanyLocation: Dispatch<any>
      name: string
      sibling: string
      disabled?: boolean
      width?: string
    },
    ref,
  ) {
    const {
      setValue,
      formState: { errors },
    } = useFormContext()
    const options = Object.keys(CountryCode) as Array<keyof typeof CountryCode>
    return (
      <Autocomplete
        ref={ref}
        sx={{ width: field.width ?? '50%', minWidth: '350px' }}
        disabled={field.disabled}
        size={field.size ?? undefined}
        onChange={(_e, option: string | null) => {
          onChange(option ?? '')
          setValue(field.name, option ?? '')
          setValue(
            field.sibling,
            option && options.includes(option as keyof typeof CountryCode)
              ? CountryCode[option as keyof typeof CountryCode]
              : '',
          )
          field.setCompanyLocation?.(option)
        }}
        value={
          value && options.includes(value as keyof typeof CountryCode)
            ? (value as keyof typeof CountryCode)
            : null
        }
        options={options}
        autoHighlight
        getOptionLabel={(option: keyof typeof CountryCode) =>
          CountryCode[option]
        }
        renderOption={(props, option) => {
          const alpha2 = countries.alpha3ToAlpha2(option) ?? ''
          console.log(option, countries)
          return (
            <Box
              key={option}
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {alpha2 && (
                <FlagImage
                  iso2={alpha2.toLowerCase()}
                  style={{ display: 'flex' }}
                />
              )}{' '}
              {CountryCode[option]} ({option})
            </Box>
          )
        }}
        renderInput={(params) => {
          const selected = countries.alpha3ToAlpha2(value)
          return (
            <TextField
              {...params}
              label={'Country'}
              InputProps={{
                ...params.InputProps,
                startAdornment: selected ? (
                  <InputAdornment position="start" sx={{ paddingLeft: '4px' }}>
                    <FlagImage
                      iso2={selected.toLowerCase()}
                      style={{ display: 'flex' }}
                    />
                  </InputAdornment>
                ) : null,
              }}
              inputProps={{
                ...params.inputProps,
                autoComplete: 'off',
              }}
              required={
                !!errors.companyLocation && !!(errors.companyLocation as any)
              }
              error={
                !!errors.companyLocation && !!(errors.companyLocation as any)
              }
              helperText={
                errors.companyLocation &&
                (errors.companyLocation as any)?.message
              }
            />
          )
        }}
      />
    )
  },
) as (props: any & { ref?: React.Ref<HTMLDivElement> }) => JSX.Element
